// extracted by mini-css-extract-plugin
export var contentContainer1 = "tps-covid-19-module--content-container-1--Xp6pS";
export var specificationsCard = "tps-covid-19-module--specificationsCard--TP9ye";
export var contentContainer2 = "tps-covid-19-module--content-container-2--ELzfE";
export var contentWithEgg = "tps-covid-19-module--content-with-egg--oZvkq";
export var eggContainer = "tps-covid-19-module--egg-container--xX5pa";
export var container = "tps-covid-19-module--container--ytyhY";